import './VideoSection.scss';

const VideoSection = () => {
  return (
    <section id="video" className="video-section section">
      <div className="container">
        <header className="video-section__header">
          <h2 className="video-section__title">문제은행 자동제작 시연 영상</h2>
          <p>아래 영상은 오래전에 촬영된 것으로 현재와 다릅니다.</p>
          <p>광고 및 홍보를 거의 안 하고 입소문만으로 운영하다 보니 개발자에게 영상 제작은 쉽지 않은 점 양해 바랍니다.</p>
          <p>나만의 디비를 구축하실 분만 문의 주세요.</p>
        </header>

        <div className="video-section__wrapper">
          <div className="video-section__container">
            <div className="video-section__frame">
              <iframe
                src="https://www.youtube.com/embed/c4Pvf3eZeZc"
                title="매쓰오토젠 시연 영상"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>

    
      </div>
    </section>
  );
};

export default VideoSection;

